import React from 'react';
import { FaPlay } from 'react-icons/fa';
import './StatsBanner.css';

export default function StatsBanner() {
  const stats = [
    { number: '82', label: 'Publications' },
    { number: '157', label: 'Conferences' },
    { number: '788', label: 'Citations' },
    { number: '20+', label: 'Researchers' }
  ];

  return (
    <section className="stats-banner">
      <div className="stats-banner__video-area">
        <div className="stats-banner__overlay"></div>
        <div className="stats-banner__content">
          <div className="stats-banner__play-wrapper">
            <button className="stats-banner__play-btn" aria-label="Play Video">
              <FaPlay />
            </button>
          </div>
          <h2 className="stats-banner__title">
            Excellence in Chemical Research<br />& Drug Discovery
          </h2>
        </div>
      </div>

      <div className="stats-banner__stats-wrapper">
        <div className="stats-banner__stats-inner">
          <div className="stats-banner__stats-box">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <span className="stat-number">{stat.number}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
